/* eslint-disable import/no-named-as-default */
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";
import { CardPageLayout } from "component-lib/CardPageLayout";
import CustomizableHeroCard from "component-lib/CustomizableHeroCard";
import { LabeledButtonWithCount } from "@loanbossinc/component-library";
import FolderIcon from "@material-ui/icons/Folder";
import { Fade } from "@material-ui/core";

import { dealGet } from "../../deal/deal.store";
import { setSelections as setSetupWizard } from "../reportingSetup/reportingSetup.store";
import LenderReportingDrawer from "../drawer";
import calcIcon from "../calcIcon.svg";

import { actionCreators } from "./dashboard.store";
import { actionCreators as dySetupActionCreators } from "../reportComponentsSetup/debtYieldSetup/debtYieldSetup.store";
import { actionCreators as dscrSetupActionCreators } from "../reportComponentsSetup/dscrSetup/dscrSetup.store";
import HeroCardContent from "./heroCardContent";
import ReportDetailsItem from "./reportDetailsItem";
import { StyledBodyWrapper, LabeledIconWrapper, Container, StyledSectionHeader } from "./styles";
import CalculationLogs from "./calculationLogs";
import moment from "moment";
import { useFlags } from "launchdarkly-react-client-sdk";

const LenderReportDetails = props => {
  const {
    deal,
    history,
    match: {
      params: { dealId, reportId }
    },
    isGuest,
    isSystemAdmin,
    reportConfigs,
    selectedReportGroup,
    sourceFileCount,
    fieldCount,
    isLenderReportingDrawerOpen,
    initialDrawerSectionName,
    getReportGroupsForDeal,
    setDashboardSelections,
    setDscrSetupToDefault,
    setDYSetupToDefault,
    getReportComponentsForReportGroup,
    getProjectedReportComponentsForReportGroup,
    getFieldCountForDeal,
    getSourceFileCountForDeal,
    recalculateRgi,
    getReportGroupInstances,
    getProjectedReportGroupInstances,
    isInstancesLoading,
    reportGroupInstances,
    toggleLockRgi,
    selectedRgiIdForLogs,
    calculationLogs,
    areLogsLoading,
    getCalculationLogs,
    reportComponentsForSelectedGroup
  } = props;

  useEffect(() => {
    setDYSetupToDefault();
    setDscrSetupToDefault();
  }, []);

  useEffect(() => {
    if (_.isEmpty(deal)) {
      props.dealGet({ dealId });
    }
    getReportGroupsForDeal({ dealId });
  }, [dealId, deal]);

  useEffect(() => {
    if (Boolean(dealId) || !isLenderReportingDrawerOpen) {
      getFieldCountForDeal({ dealId });
      getSourceFileCountForDeal({ dealId });
    }
  }, [dealId, isLenderReportingDrawerOpen]);
  
  const [frequencyType, setFrequencyType] = useState("");

  useEffect(() => {
    const reportGroup = reportConfigs && reportConfigs.find(rep => rep.id === reportId);
    if (!reportGroup && reportConfigs) {
      history.push(`/deal/${dealId}/lender-reports`);
    } else {
      setDashboardSelections({ selectedReportGroup: reportGroup });
      if(reportGroup) {
        setFrequencyType(reportGroup.frequency);
      }
    }
  }, [reportId, reportConfigs, selectedReportGroup]);

  useEffect(() => {
    getReportComponentsForReportGroup({ reportGroupId: reportId });
    getProjectedReportComponentsForReportGroup({ reportGroupId: reportId });
    if (!reportGroupInstances) {
      getReportGroupInstances({ reportGroupId: reportId });
      getProjectedReportGroupInstances({ reportGroupId: reportId });
    }
  }, [reportId]);

  useEffect(() => () => setDashboardSelections({ reportGroupInstances: null, selectedRgiIdForLogs: null }), []);

  const closeDrawer = () => setDashboardSelections({ isLenderReportingDrawerOpen: false, initialDrawerSectionName: null });

  const heroCard = () => {
    if (!deal) {
      return null;
    }

    return (
      <div>
        <CustomizableHeroCard
          {...props}
          title={deal.name}
          backLabel="All lender compliance reports"
          cardContent={<HeroCardContent {...props} dealId={dealId} reportId={reportId} />}
          onBackButtonClick={() => history.push(`/deal/${dealId}/lender-reports`)}
        />

        {!isGuest && (
          <LabeledIconWrapper>
            <Container>
              <LabeledButtonWithCount
                label="Source Files"
                icon={<FolderIcon />}
                count={sourceFileCount}
                style={{ width: "100%", borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: "#fff" }}
                onClick={() => setDashboardSelections({ isLenderReportingDrawerOpen: true, initialDrawerSectionName: "source-file-management" })}
              />
              <LabeledButtonWithCount
                label="Fields"
                icon={<img src={calcIcon} alt="Field Icon" height={18} width={18} />}
                count={fieldCount}
                style={{ width: "100%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: "#fff" }}
                onClick={() => setDashboardSelections({ isLenderReportingDrawerOpen: true, initialDrawerSectionName: "field-management" })}
              />
            </Container>
          </LabeledIconWrapper>
        )}
      </div>
    );
  };

  const previewReport = (previewType, rgiId) => {
    history.push(`/deal/${dealId}/lender-reports-preview/${previewType}/${reportId}/${rgiId}/${ encodeURIComponent(deal.name) }`);
  };

  const isAsOfDateBeforeCurrentRgi = (submittedRgiDate, currentRgiDate) => {
    const current = moment.utc(currentRgiDate);
    const submitted = moment.utc(submittedRgiDate);

    return submitted.isSameOrBefore(current);
  };

  const rgiSubmittedOrDraft = rgi => rgi.isSubmitted || rgi.isDraft;

  const [draftRgi, setDraftRgi] = useState({});
  const [rgisToBeSentToLender, setRgisToBeSentToLender] = useState([]);
  const [lastSubmitted, setLastSubmitted] = useState({});
  const [projectedRgis, setProjectedRgis] = useState({});
  const { bar840FrontEndIsProjectedComponentsFeature } = useFlags();
  useEffect(() => {
    if(reportGroupInstances) {
      const draft = reportGroupInstances.sort((a,b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf())
                                        ?.find(rgi => rgi.isDraft && !rgi.isProjected);
      setDraftRgi(draft);
      if(bar840FrontEndIsProjectedComponentsFeature) {
        setProjectedRgis(reportGroupInstances.sort((a,b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf())
                                            ?.find(rgi => rgi.isProjected === true));
      }
      const rgisToBeSent = _.orderBy(reportGroupInstances.filter(
        rgi => !rgiSubmittedOrDraft(rgi)), "asOfDate", "asc")[0];
        setRgisToBeSentToLender(rgisToBeSent);
      const currentRgiDate = rgisToBeSent ? rgisToBeSent.asOfDate : new Date();
      const recentLastSubmitted = _.orderBy(reportGroupInstances.filter(
        rgi => rgi.isSubmitted === true && isAsOfDateBeforeCurrentRgi(rgi.asOfDate, currentRgiDate)), "asOfDate", "desc")[0];
      setLastSubmitted(recentLastSubmitted);
    } else {
      setDraftRgi({});
      setProjectedRgis({});
      setRgisToBeSentToLender([]);
      setLastSubmitted({});
    }

  }, [reportGroupInstances]);

  const [displaySection, setDisplaySection] = useState(false);

  const doesDyOrDscrHaveLineItems = (component) => {
    return component && component.calculations?.selectedLoans.some((loan) => loan.lineItem);
  };

  const shouldDisplaySection = () => {
    const noi = reportComponentsForSelectedGroup && reportComponentsForSelectedGroup
                                        .sort((a,b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf())
                                        ?.find(comp => comp.type === "NOI");

    if (!noi || !noi.lineItems || noi.lineItems.length === 0) {
      return false;
    }

    const dy = reportComponentsForSelectedGroup && reportComponentsForSelectedGroup
                                        .sort((a,b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf())
                                        ?.find(comp => comp.type === "DebtYield");

    const dscr = reportComponentsForSelectedGroup && reportComponentsForSelectedGroup
                                      .sort((a,b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf())
                                      ?.find(comp => comp.type === "DSCR");

    if (selectedReportGroup?.shouldCalculateDebtYield && selectedReportGroup?.shouldCalculateDscr) {
      return doesDyOrDscrHaveLineItems(dy) && doesDyOrDscrHaveLineItems(dscr);
    }
    if (selectedReportGroup?.shouldCalculateDebtYield) {
      return doesDyOrDscrHaveLineItems(dy);
    }
    if (selectedReportGroup?.shouldCalculateDscr) {
      return doesDyOrDscrHaveLineItems(dscr);
    }

    return true;
  };

  useEffect(() => {
    setDisplaySection(shouldDisplaySection());
  }, [reportComponentsForSelectedGroup]);

  const body = () => (
    <>
      {selectedRgiIdForLogs ? (
        <CalculationLogs
          selectedRgiIdForLogs={selectedRgiIdForLogs}
          calculationLogs={calculationLogs}
          areLogsLoading={areLogsLoading}
          getCalculationLogs={getCalculationLogs}
          setDashboardSelections={setDashboardSelections}
        />
      ) : (
        <Fade in timeout={1000}>
          <StyledBodyWrapper>
          {(displaySection && frequencyType !== "monthly" && draftRgi && Object.keys(draftRgi).length !== 0) && (
              <>
              <StyledSectionHeader>Calculations Using Current Data</StyledSectionHeader>
                <ReportDetailsItem
                  rgi={draftRgi}
                  key={draftRgi.id}
                  previewReport={previewReport}
                  isGuest={isGuest}
                  reportId={reportId}
                  recalculateRgi={recalculateRgi}
                  toggleLockRgi={toggleLockRgi}
                  dealName={deal.name}
                  dealId={dealId}
                  isSystemAdmin={isSystemAdmin}
                  setDashboardSelections={setDashboardSelections}
                  displayRows={displaySection}
                />
            </>
            )}
            {(displaySection && rgisToBeSentToLender && Object.keys(rgisToBeSentToLender).length !== 0) && (
              <>
                <StyledSectionHeader>Calculations to be Sent to Lender</StyledSectionHeader>
                  <ReportDetailsItem
                    rgi={rgisToBeSentToLender}
                    key={rgisToBeSentToLender.id}
                    previewReport={previewReport}
                    isGuest={isGuest}
                    reportId={reportId}
                    recalculateRgi={recalculateRgi}
                    toggleLockRgi={toggleLockRgi}
                    dealName={deal.name}
                    dealId={dealId}
                    isSystemAdmin={isSystemAdmin}
                    setDashboardSelections={setDashboardSelections}
                    displayRows={displaySection}
                  />
              </>
            )}
            {(displaySection && projectedRgis && Object.keys(projectedRgis).length !== 0) && (
              <>
                <StyledSectionHeader>Projected Calculations</StyledSectionHeader>
                  <ReportDetailsItem
                    rgi={projectedRgis}
                    key={projectedRgis.id}
                    previewReport={previewReport}
                    isGuest={isGuest}
                    reportId={reportId}
                    recalculateRgi={recalculateRgi}
                    toggleLockRgi={toggleLockRgi}
                    dealName={deal.name}
                    dealId={dealId}
                    isSystemAdmin={isSystemAdmin}
                    setDashboardSelections={setDashboardSelections}
                    displayRows={displaySection}
                  />
              </>
            )}
            {(lastSubmitted && Object.keys(lastSubmitted).length !== 0) && (
              <>
                <StyledSectionHeader>Prior Calculation</StyledSectionHeader>
                  <ReportDetailsItem
                    rgi={lastSubmitted}
                    key={lastSubmitted.id}
                    previewReport={previewReport}
                    isGuest={isGuest}
                    reportId={reportId}
                    recalculateRgi={recalculateRgi}
                    toggleLockRgi={toggleLockRgi}
                    dealName={deal.name}
                    dealId={dealId}
                    isSystemAdmin={isSystemAdmin}
                    setDashboardSelections={setDashboardSelections}
                    displayRows={true}
                  />
              </>
            )}
          </StyledBodyWrapper>
        </Fade>
      )}
    </>
  );

  if (isInstancesLoading || !deal) {
    return null;
  }

  return (
    <>
      <CardPageLayout {...props} isReversed bannerImageUrl={deal && deal.imageLarge} cardComponent={heroCard()} bodyComponent={body()} />
      <LenderReportingDrawer
        authentication={props.authentication}
        closeDrawer={closeDrawer}
        deal={deal}
        initialDrawerSectionName={initialDrawerSectionName}
        isOpen={isLenderReportingDrawerOpen}
      />
    </>
  );
};

const mapStateToProps = ({ lenderReportList, newDeal: { deal }, authentication: { user, isGuest, isSystemAdmin } }) => ({
  deal,
  user,
  isGuest,
  isSystemAdmin,
  ...lenderReportList
});

const mapDispatchToProps = dispatch => bindActionCreators({ dealGet, setSetupWizard, ...actionCreators, ...dySetupActionCreators, ...dscrSetupActionCreators }, dispatch);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LenderReportDetails);
